import { render, staticRenderFns } from "./MessageThreadsSort.vue?vue&type=template&id=49dc0623&scoped=true&"
import script from "./MessageThreadsSort.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsSort.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadsSort.vue?vue&type=style&index=0&id=49dc0623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc0623",
  null
  
)

export default component.exports